/** SEO-тексты и FAQ страницы /steam (синхрон с visoria/seo/steam-topup-page.js). */

export const STEAM_TOPUP_TITLE =
  "Пополнение Steam из России по логину — оплата СБП | Trendy shop";

export const STEAM_TOPUP_DESCRIPTION =
  "Пополните кошелёк Steam из России и СНГ: введите логин и сумму в рублях, оплатите по СБП. Деньги зачисляются на аккаунт — это не код. Сумма от 150 до 25 000 ₽, ПСК до 3%.";

export const STEAM_TOPUP_FAQ = [
  {
    q: "Это код или пополнение по логину?",
    a: "На этой странице деньги зачисляются на кошелёк Steam по логину. Код вы не получаете. Подарочные карты Steam — отдельно: в Telegram-боте или на странице кодов Steam.",
  },
  {
    q: "Какой логин указывать?",
    a: "Нужен логин для входа в Steam (account name), а не никнейм в профиле. Инструкция со скриншотами — в блоке «Как найти свой логин» выше.",
  },
  {
    q: "Какие страны можно пополнять?",
    a: "Россия, Беларусь, Украина, Армения, Азербайджан, Грузия, Казахстан, Киргизия, Молдова, Таджикистан, Туркменистан и Узбекистан. Для российского аккаунта в Steam зачисляется ровно указанная сумма в рублях.",
  },
  {
    q: "Сколько ждать зачисление?",
    a: "Обычно меньше 10 минут после успешной оплаты. Если за 2 часа баланс не изменился — напишите в техподдержку.",
  },
  {
    q: "Что такое ПСК?",
    a: "ПСК — персональное снижение комиссии за услугу пополнения, а не суммы в Steam. За каждые полные 1 000 ₽ успешных пополнений по логину — +0,1% ПСК, максимум 3% (с 30 000 ₽ накопленного). Первый заказ без скидки.",
  },
  {
    q: "Чем отличается от карт Steam на сайте?",
    a: "Пополнение по логину сразу кидает деньги на кошелёк. Карты — это код, который активируют вручную; удобно для подарка.",
  },
];

const SITE = "https://trendy-eng-shop.ru";

export function steamTopupJsonLd() {
  return [
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Главная", item: `${SITE}/` },
        {
          "@type": "ListItem",
          position: 2,
          name: "Пополнение Steam",
          item: `${SITE}/steam`,
        },
      ],
    },
    {
      "@context": "https://schema.org",
      "@type": "Service",
      name: "Пополнение Steam по логину",
      description: STEAM_TOPUP_DESCRIPTION,
      url: `${SITE}/steam`,
      areaServed: ["RU", "BY", "UA", "AM", "AZ", "GE", "KZ", "KG", "MD", "TJ", "TM", "UZ"],
      offers: {
        "@type": "Offer",
        priceCurrency: "RUB",
        availability: "https://schema.org/InStock",
        url: `${SITE}/steam`,
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: STEAM_TOPUP_FAQ.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: { "@type": "Answer", text: item.a },
      })),
    },
  ];
}
